import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  TemplateRef,
  Type,
  ViewContainerRef,
} from '@angular/core';
import { LoadUntilComponent } from './components/load-until/load-until.component';

@Directive({
  selector: '[tcsLoadUntil]',
})
export class LoadUntilDirective implements OnDestroy, OnChanges {
  @Input() public tcsLoadUntilContext: any;
  @Input() public tcsLoadUntilTemplate: TemplateRef<any> | Type<any>;
  @Input() public tcsLoadUntil: any;

  private _componentRef: ComponentRef<any>;

  constructor(
    private host: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
  ) {}

  public ngOnDestroy() {
    if (this._componentRef != null) {
      this._componentRef.destroy();
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    this._executeChange();
  }

  private _executeChange() {
    if ((this.tcsLoadUntil ?? false) === false) {
      const ref =
        this.tcsLoadUntilTemplate == null ? LoadUntilComponent : this.tcsLoadUntilTemplate;
      if (ref instanceof TemplateRef) {
        this._changeTemplate(ref, this.tcsLoadUntilContext);
      } else {
        this._changeComponent(ref, this.tcsLoadUntilContext);
      }
    } else {
      this._changeTemplate(this.templateRef, { $implicit: this.tcsLoadUntil });
    }
  }

  private _changeTemplate(templateRef: TemplateRef<any>, context?: any) {
    this.viewContainer.clear();
    this.viewContainer.createEmbeddedView(templateRef, context);
  }

  private _changeComponent(component: Type<any>, context?: any) {
    if (this._componentRef != null) {
      this._componentRef.destroy();
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(component);
    this._componentRef = this.viewContainer.createComponent(factory);
    if (context != null) {
      this._componentRef.instance.context = context;
    }
    // WIP
    // if (context != null) {
    //   // wire up @input(s) and @output(s) between context and component.
    //   Object.getOwnPropertyNames(context).forEach(prop => {
    //     const tmp = this._componentRef.instance[prop];
    //     if (
    //       tmp != null &&
    //       tmp instanceof EventEmitter &&
    //       this.tcsLoadUntilLoadingContext[prop] != null &&
    //       typeof this.tcsLoadUntilLoadingContext[prop] === 'function'
    //     ) {
    //       tmp
    //         .pipe(takeWhile(() => !this._componentRef.hostView.destroyed))
    //         .subscribe(($event: any) => {
    //           this.tcsLoadUntilLoadingContext[prop]($event);
    //         });
    //     } else if (this._componentRef.instance[prop] == null) {
    //       this._componentRef.instance[prop] = this.tcsLoadUntilLoadingContext[
    //         prop
    //       ];
    //     }
    //   });
    //   this._componentRef.changeDetectorRef.detectChanges();
    // }
  }
}
